import { Flex } from "antd";
import { castArray } from "lodash-es";

type SecondaryFilterLabelProps = {
  value: { value: string; label: string } | { value: string; label: string }[];
};
export const SecondaryFilterLabel = ({ value }: SecondaryFilterLabelProps) => {
  const valueArray = castArray(value);
  const displayedValues = valueArray.slice(0, 2);
  const remainingCount = valueArray.length - displayedValues.length;

  return (
    <Flex gap={12} align="center" justify="space-between">
      <Flex gap={8} align="center">
        {displayedValues.map((val) => (
          <span key={val.value}>{val?.label}</span>
        ))}
        {remainingCount > 0 && <span>+{remainingCount}</span>}
      </Flex>
    </Flex>
  );
};
